import React from "react";

const Edit = ({ color, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={`size-4 ${className}`}
    >
      <path
        d="M11.1159 3.01501L1.21212 12.9196C1.16225 12.9696 1.12671 13.0321 1.1092 13.1005L0.01142 17.5066C-0.00472562 17.572 -0.00373617 17.6405 0.0142928 17.7054C0.0323217 17.7703 0.0667808 17.8294 0.114342 17.8771C0.187394 17.9499 0.286305 17.9908 0.389445 17.9909C0.421262 17.9909 0.452957 17.987 0.483814 17.9792L4.88996 16.8813C4.95847 16.8641 5.02101 16.8285 5.07088 16.7785L14.9756 6.87461L11.1159 3.01501ZM17.4292 1.66453L16.3268 0.56211C15.5899 -0.174715 14.3057 -0.173984 13.5697 0.56211L12.2193 1.91259L16.0788 5.77204L17.4292 4.4216C17.7973 4.0537 18 3.56398 18 3.04316C18 2.52233 17.7973 2.03262 17.4292 1.66453Z"
        fill={color || "#1E4387"}
      />
    </svg>
  );
};
export default Edit;
